var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNarrowShortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70685 6.293C9.89455 6.48053 10 6.73484 10 7C10 7.26516 9.89455 7.51947 9.70685 7.707L5.70184 11.707C5.51408 11.8945 5.25945 11.9998 4.99395 11.9998C4.72846 11.9998 4.47383 11.8945 4.28607 11.707L0.281063 7.707C0.0986771 7.5184 -0.00224342 7.2658 3.785e-05 7.0036C0.00231912 6.7414 0.107619 6.49059 0.29326 6.30518C0.4789 6.11977 0.730027 6.0146 0.992552 6.01233C1.25508 6.01005 1.50799 6.11084 1.69683 6.293L3.9927 8.586V1C3.9927 0.734784 4.09819 0.48043 4.28596 0.292893C4.47373 0.105357 4.72841 0 4.99395 0C5.2595 0 5.51417 0.105357 5.70195 0.292893C5.88972 0.48043 5.99521 0.734784 5.99521 1V8.586L8.29108 6.293C8.47884 6.10553 8.73347 6.00021 8.99896 6.00021C9.26446 6.00021 9.51908 6.10553 9.70685 6.293Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowShortDown);
export default __webpack_public_path__ + "static/media/ArrowNarrowShortDown.38372cfc8148c16d6ecf0dd3f4467c64.svg";
export { ForwardRef as ReactComponent };